export enum Gender {
  MALE = '男',
  FEMALE = '女',
}

export interface BirthDetails {
  date: string; // YYYY-MM-DD
  time: string; // HH:mm
  gender: Gender;
}

export interface Star {
  name: string;
  brightness?: string;
  type: 'major' | 'minor' | 'bad' | 'other';
}

export interface Palace {
  index: number;
  name: string; // e.g., 命宮, 財帛宮
  earthlyBranch: string; // e.g., 子, 丑
  heavenlyStem: string; // e.g., 甲, 乙
  majorStars: Star[];
  minorStars: Star[];
  adjectiveStars: Star[]; // Helper stars
}

export interface AstrolabeData {
  solarDate: string;
  lunarDate: string;
  chineseDate: string;
  fiveElementsClass: string; // 五行局
  palaces: Palace[];
}

export enum SageState {
  IDLE = 'IDLE',
  LISTENING = 'LISTENING',
  THINKING = 'THINKING',
  TALKING = 'TALKING',
  READING = 'READING',
}
